import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { EMPTY, Observable } from 'rxjs';

import { KibanaRegisterModel } from '@app/core/models/kibana.model';

import { environment } from '@env/environment';

import { HttpResource } from './resource/http-resource';

@Injectable({
  providedIn: 'root'
})
export class KibanaService {
  constructor(private http: HttpResource) {}

  postKibanaLog(data: KibanaRegisterModel): Observable<HttpResponse<void>> {
    if (environment.kibanaEnabled === false) {
      return EMPTY;
    }

    return this.http.post<HttpResponse<void>>(`/custom/kibana`, data);
  }
}
